export default __webpack_public_path__ + "static/media/portfolio-tab-redo.804d43bd.gif";